import React, { useStat, useEffect, useRef, useState } from 'react';
import { connect, useSelector, useDispatch} from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
  queryDocumentV2,
  uploadDocumentV2,
  uploadDocumentV2AzureService,
  uploadUrlV2,
  getTrainedDataV2,
  deleteTrainedDataV2,
  sendInputAnswerV2,
  getDocUploadStatusV2,
  deleteDocumentV2,
  getWalkthroughs,
  updateWalkthroughs,
  uploadInstructionV2,
  getChatHistoryV2,
  getSqlQueryV2,
  uploadTextV2,
  updateTextV2,
  getAudio,
  uploadSharepointData,
  uploadGoogleDriveData,
} from "../../../../../../../redux/actions/collectionsV2";
import "../../../../../../../css/workspace.css";
import {
    Tabs,
    Button,
    Tooltip
  } from "antd";
import {
  ExportOutlined,
  FullscreenExitOutlined,
  CloseOutlined,
  HistoryOutlined,
  ImportOutlined
} from "@ant-design/icons";
import systemIcon from "../../../../../../../images/chat-avt.png";
import editIcon from "../../../../../../../images/edit-icon.svg";
import chatHistoryIcon from "../../../../../../../images/history-icon-2.svg";
import UploadedDocs from './uploadedDocs';
import ChatBot from './chatBot';
import TrainedData from './trainedData';

const AskAICoach = ({ expandedBox, setExpandedBox }) => {

    const { TabPane } = Tabs;
    const [chatHistoryFlag, setChatHistoryFlag] = useState(false);
    const [_chatHistoryList, _setChatHistoryList] = useState([]);
    const [chatHistoryItem, setChatHistoryItem] = useState([]);

    const expandBox = (boxId) => {
        setExpandedBox(boxId);
    };
    const collapseBox = () => {
        setExpandedBox(null);
    };

    const dispatch = useDispatch();
    const queryParams = useLocation().search;
    const collectionName =  new URLSearchParams(queryParams).get("name");

    const userEmail = useSelector((state) => state.userReducer.user?.email);

    const chatHistoryDataList = useSelector(
      (state) => state.collectionReducer.chatHistoryData
    );

    useEffect(() => {
      const fetchData = async () => {
        try {
          dispatch(getChatHistoryV2(new URLSearchParams(queryParams).get("name"), userEmail))
        } catch (error) {
          console.error("Failed to fetch data:", error);
        }
      };
      fetchData();
    }, []);

    useEffect(() => {
      _setChatHistoryList(chatHistoryDataList);
    }, [chatHistoryDataList]);

    const chatHistoryData = async (collectionName) => {
      setChatHistoryFlag(true);
      // dispatch(getChatHistoryV2(collectionName, userEmail)).then(() => {
      //   setChatHistoryFlag(true);
      // });
    };

    let queryBody = [];
    queryBody.push(
        <div className="mac-chat mac-left">
        <div className="mac-avt">
            <img src={systemIcon} alt="" />
        </div>
        <div className="mac-text">
            <p className="mac-white">Hi, I'm Super</p>
            <p className="mac-white">How may I assist you today?</p>
        </div>
        </div>
    );

    let chatHistoryList =
    _chatHistoryList?.length > 0 && _chatHistoryList != "No data found "
      ? _chatHistoryList?.map((item, index) => (
          <div className="ch-list-item" key={index}>
            <div
              className="ch-list-item-inner"
              onClick={() => {
                setChatHistoryItem(item);
                //onOpenChatHistory(item);
              }}
            >
              <p>{item.question}</p>
            </div>
          </div>
        ))
      : [];

    return(
        <>
         <div
          className={`flex-item-grid ${
            expandedBox === "box3" ? "expanded expanded-chat" : ""
          } ${expandedBox && expandedBox !== "box3" ? "hidden" : ""}`}
          id="box3"
        >
          <div className="fl-grid-block tab-full-block">
            <span className="block-name">Ask AI Coach</span>
            <div className="tab-flex-block">
              <div className="wk-chat-uploads collection-sidebar">
                
                  <div className="title-flex">
                    <h2 className="csd-title">Uploaded Files</h2>
                    <div className="new-chat-close">
                      <Tooltip title="Chat History">
                        <Button
                        type="link"
                          onClick={() => {
                            chatHistoryData(collectionName);
                          }}                  
                          className="ch-history-btn"
                        >
                          <img src={chatHistoryIcon} width="22" />
                        </Button>
                      </Tooltip>
                      <Button
                      outline
                      style={{padding: 0}}
                      type="link"
                      onClick={() => {
                        setChatHistoryItem(queryBody);
                        // setQueryData(queryBody);
                        // setQueryResponse("");
                        // setChatContext(" ");
                      }}
                    >
                       <Tooltip title="New Chat">
                      <img
                        src={editIcon}
                        width="22"
                      />
                      </Tooltip>
                      </Button>
                    </div>
                  </div>
                  
                    <UploadedDocs />             
              </div>
              {chatHistoryFlag ? (
                <div className="wk-chat-history collection-sidebar scrollable">                 
                 
              <div className="flex-title-chat-hs chat-expanded-title">
                <h4>Chat History</h4>
                <div className="new-chat-close">
                  <Tooltip title="Hide Chat History">
                    <CloseOutlined onClick={() => setChatHistoryFlag(false)} />
                  </Tooltip>
                </div>
              </div>
              <div className="resource-list scrollable wk-chat-history-list">
              {chatHistoryList}
            </div>               
                </div>
              ) : null}
              <Tabs
                defaultActiveKey="1"
                type="card"
                tabBarExtraContent={
                  expandedBox === "box3" ? (
                    <FullscreenExitOutlined
                      onClick={collapseBox}
                      className="tab-full-icon"
                    />
                  ) : (
                    <ExportOutlined
                      onClick={() => expandBox("box3")}
                      className="tab-full-icon"
                    />
                  )
                }
              >
                <TabPane tab="Ask AI Coach" key="1">
                <ChatBot chatHistoryFlag={chatHistoryFlag} setChatHistoryFlag={setChatHistoryFlag} chatHistoryItem={chatHistoryItem}/>
                  {/* <ChatBot /> */}
                </TabPane>
                <TabPane tab="Trained Data" key="2">
                  <TrainedData />
                </TabPane>
              </Tabs>
            </div>
          </div>
        </div>
        </>
    )

}
export default AskAICoach;